export default __webpack_public_path__ + "static/media/your-widget.72287655.svg";